const enMessages = {
  'HomePage:Text:Body2':`
    <h4>🍺 A new era for the beer community</h4>
    <p>The Copa de las Californias was born from the collaborative spirit of the regional beer scene. After years of growth and collaboration with the Pizza & Cheve Fest, the beer community decided to take it a step further.</p>
    <p>The result? A international, competitive, and cultural festival that seeks to celebrate the best craft beers from both Mexican and American Californias, in a single meeting place: La Paz, Baja California Sur.</p>
    <h4>🌱 Evolution with a purpose</h4>
    <p>This new format is more than a name change.</p>
    <p>It's the natural evolution of a movement that has matured:</p>
    <ul>
    <li>Many members of the BCS Brewers Club are becoming certified as BJCP judges.</li>
    <li>The community drives quality, professionalism, and creativity.</li>
    <li>The competition is designed with rigor and passion for beer.</li>
    </ul>
    <h4>🇲🇽 🇺🇸 One glass. Three regions. One spirit.</h4>
    <p>More than 40 independent breweries compete for recognition from the public and judges.</p>
    <p>From Tijuana to San Diego, passing through Ensenada, Mulegé, and Los Cabos, this cup is the meeting point to taste, learn, and celebrate.</p>
    <h4>📍 La Paz, B.C.S.</h4>
    <p>With the sea in the background and the soul of beer at the forefront.</p>
    <p>The La Paz boardwalk will be the setting for this sensorial celebration:</p>
    <p>Beer, music, gastronomy, and community in a unique setting.</p>
    <ul>
      <li>🎉 Coming soon: Copa de las Californias 2025</li>
      <li>🗓️ Date to be announced</li>
      <li>📍 Malecón Costero, La Paz, B.C.S.</li>
      <li>🥇 Official BJCP Competition</li>
      <li>🍕 Pizza & Cheve Fest Heritage</li>
    </ul>
  `,
  'HomePage:Text:Body3': `
    <p>The cup brings together more than 40 independent breweries that represent the beer diversity of the three Californias.</p>
    <p>🔥 Compete in styles such as:</p>
    <ul>
      <li>IPA/Hazy IPA</li>
      <li>Stout, Porter, and Dark Ales</li>
      <li>Lagers, Pale Ale, Amber, and more</li>
    </ul>
  `,
  'HomePage:Text:Body4': `
    <p>Images of the festivals that inspired us:</p>
    <p><b>Ceviche Fest, Baja Soul Fest, and Pizza & Cheve Fest.</b></p>
    <p>Events that paved the way for what is now the Copa de las Californias.</p>
    <p>Explore the evolution of our community in each photo.</p>
  `,
  'HomePage:Text:Body5': `
    <p>Be part of the most important beer event in the Pacific. Whether you're a brewery, media outlet, or collaborator, this is your space.</p>
  `,
  'HomePage:Text:Body6': `
    <h4>🍻 Are you a brewery? Register to compete</h4>
    <p>The Copa de las Californias is an international showcase for your beer to stand out in front of colleagues and knowledgeable audiences.</p>
    <p>Breweries from Baja California, Baja Sur, and California, USA, participate, competing in styles evaluated by certified BJCP judges.</p>
    <p>In addition to the competition, you can have your own booth at the festival, where thousands of attendees can learn about and enjoy your styles.</p>
    <p>✅ Limited capacity | ✅ Clear rules | ✅ Real visibility</p>
  `,
  'HomePage:Text:Body7': `
    <h4>Are you part of a media organization, a food influencer, or interested in collaborating with the festival experience?</h4>
    <p>We're looking for creative, committed partners who are passionate about craft beer, culture, and the community.</p>
    <p>Whether it's for coverage, commercial partnerships, or cultural proposals, we want to hear from you.</p>
    <ul>
      <li>🎤 Press Coverage</li>
      <li>🎨 Activations and Experiences</li>
      <li>📢 Brand Partnerships</li>
    </ul>
    <h5>👉 Request your accreditation or send us your proposal</h5>
  `,
  'HomePage:Text:Body8': `
    <h4>🧑‍⚖️ International Guest Judges</h4>
    <p>This year, the Copa de las Californias will feature two key figures from the beer world, both members of the Beer Judge Certification Program (BJCP):</p>
  `,
  'HomePage:Text:Body9': `
    <h5>👨‍🔬 John Palmer</h5>
    <p>Author of How to Brew, one of the most influential guides to brewing beer worldwide. A technical expert and trainer for hundreds of craft brewers.</p>
  `,
  'HomePage:Text:Body10': `
    <h5>👩‍🏫 Sandy Cockerham</h5>
    <p>BJCP judge with over 15 years of experience in international competitions. Recognized for her sensory approach and her work promoting women in the beer world.</p>
  `,
  'HomePage:Text:CallToAction01': 'Take Part',
  'HomePage:Text:CallToAction02': 'See festival details',
  'HomePage:Text:CallToAction03': 'I want to compete (Pro)',
  'HomePage:Text:CallToAction04': 'I want to compete (Amateur)',
  'HomePage:Text:CallToAction05': 'I want to colaborate',
  'HomePage:Text:Heading1': 'Three regions. One passion: craft beer',
  'HomePage:Text:Heading2': '🏆 Copa de las Californias 2025',
  'HomePage:Text:Heading3': 'The brewers making history',
  'HomePage:Text:Heading4': '📸 Gallery',
  'HomePage:Text:Heading5': '🤝 Participate in Copa de las Californias',
  'HomePage:Text:Subheading1': 'For the first time, the flavors, styles, and talents of the three Californias come together in a festival where hops, malt, and creativity will take center stage',
  'HomePage:Text:Support': '🏆 Copa de las Californias',
  'MainFooter:Text:Rights': 'Copa de las Californias. All rights reserved',
  'MainHeader:Link:Fest': 'Fest',
  'MainHeader:Link:Brewers': 'Brewers',
  'MainHeader:Link:Gallery': 'Gallery',
  'MainHeader:Link:TakePart': 'Take Part',
  'NotFoundPage:Alt:Error': 'Error 404',
  'NotFoundPage:Heading:Error': 'Error 404: Page not found',
  'NotFoundPage:Description:Error': 'The page you\'re looking for is not available. Please check the URL and try again.',
};

export default enMessages;
